import { AbstractFWGlobalParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWGlobalParams';
export class FWPauseAdGlobalParams extends AbstractFWGlobalParams {
    adParams;
    constructor(argument) {
        super({
            name: 'FWPauseAdGlobalParams',
            ...argument
        });
        this.adParams = this.#overrideParams(this.#createParams(), argument?.paramsOverride);
    }
    #createParams() {
        const params = {
            asnw: this.fwConstants.assetNetworkId,
            caid: this.apiMetadata?.contentId,
            csid: this.siteSessionData?.csid?.toLowerCase() || this.createSiteSectionId(),
            flag: this.pauseAdConstants.capabilitiesFlag,
            metr: this.fwConstants.defaultCapabilities,
            nw: this.fwConstants.networkId,
            prof: this.fwConstants.playerProfile,
            pvrn: this.pauseAdConstants.pageView,
            resp: this.pauseAdConstants.response,
            ssnw: this.fwConstants.siteSectionNetworkId,
            vprn: this.pauseAdConstants.videoPlayer
        };
        this.logger?.log('createParams:', params);
        return params;
    }
    #overrideParams(params, overrides) {
        if (this.utils?.Type?.isEmpty(params) ||
            this.utils?.Type?.isEmpty(overrides)) {
            return params;
        }
        Object.entries(overrides).forEach(([key, value]) => {
            if (params[key] &&
                !this.utils?.Type?.isEmpty(value)) {
                const prevValue = params[key];
                params[key] = value;
                this.logger?.log('overrideParams:', 'parameter overridden...', '\nkey:', key, '\nprevious value:', prevValue, '\nnew value:', params[key]);
            }
        });
        this.logger?.log('overrideParams:', params);
        return params;
    }
    get adParameters() {
        return this.adParams;
    }
}
